import React from "react";
import {
  AppBar,
  Toolbar,
  CssBaseline,
  makeStyles,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import DrawerComponent from "./Drawer";
import logo from '../images/logo.png';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(0, 2),
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  logoImage: {
    width: 160,
    height: "auto",
    [theme.breakpoints.down("sm")]: {
      width: 110,
    },
  },
  navlinks: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  link: {
    textDecoration: "none",
    color: "white",
    fontSize: "17px",
    paddingBottom: 3,
    borderBottom: "2px solid transparent",
    "&:hover": {
      color: "yellow",
      borderBottom: "2px solid yellow",
    },
  },
  activeLink: {
    color: "yellow",
    borderBottom: "2px solid yellow",
  },
  productBtn: {
    color: "white",
    fontSize: "17px",
    background: "none",
    border: "none",
    borderBottom: "2px solid transparent",
    paddingBottom: 3,
    cursor: "pointer",
    padding: 0,
    fontFamily: "inherit",
    "&:hover": {
      color: "yellow",
      borderBottom: "2px solid yellow",
    },
  },
  productBtnActive: {
    color: "yellow",
    borderBottom: "2px solid yellow",
  },
}));

function Navbar() {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isProductActive = ["/realestate", "/hotelBooking"].includes(location.pathname);

  const recordButtonPosition = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const realestatePage = () => {
    setMenuOpen(false);
    navigate("/realestate");
  };

  const hotelBookingPage = () => {
    setMenuOpen(false);
    navigate("/hotelBooking");
  };

  return (
    <AppBar position="static">
      <CssBaseline />
      <Toolbar className={classes.toolbar}>
        <div className={classes.logoContainer}>
          <img src={logo} alt="IndoHive logo" className={classes.logoImage} />
        </div>

        {isMobile ? (
          <DrawerComponent />
        ) : (
          <nav className={classes.navlinks}>
            <Link
              to="/"
              className={`${classes.link} ${location.pathname === "/" ? classes.activeLink : ""}`}
            >
              Home
            </Link>

            <button
              onClick={recordButtonPosition}
              className={`${classes.productBtn} ${isProductActive ? classes.productBtnActive : ""}`}
            >
              Product
            </button>
            <Menu anchorEl={anchorEl} open={menuOpen} onClose={closeMenu}>
              <MenuItem
                onClick={realestatePage}
                selected={location.pathname === "/realestate"}
              >
                Real estate
              </MenuItem>
              <MenuItem
                onClick={hotelBookingPage}
                selected={location.pathname === "/hotelBooking"}
              >
                Hotel Booking
              </MenuItem>
            </Menu>

            <Link
              to="/about"
              className={`${classes.link} ${location.pathname === "/about" ? classes.activeLink : ""}`}
            >
              About
            </Link>
            <Link
              to="/contact"
              className={`${classes.link} ${location.pathname === "/contact" ? classes.activeLink : ""}`}
            >
              Contact
            </Link>
          </nav>
        )}
      </Toolbar>
    </AppBar>
  );
}
export default Navbar;
